<header
  class="sticky top-0 z-99999 flex w-full border-gray-200 dark:border-gray-800 xl:border-b"
  [ngClass]="headerBackgroundClass"
>
  <div class="flex flex-col items-center justify-between grow xl:flex-row xl:px-6">
    @if (!isDesktopHeader) {
      <div
        class="flex w-full items-center justify-between gap-2 border-b border-gray-200 px-3 py-3 dark:border-gray-800 sm:gap-4"
      >
        <button
          type="button"
          (click)="toggleMobileSidebar()"
          aria-label="Open main menu"
          title="Open main menu"
          class="shrink-0 rounded-lg transition-opacity hover:opacity-85 focus:outline-none"
        >
          <img
            class="h-14 w-14 object-contain dark:hidden sm:h-16 sm:w-16"
            src="./assets/logo.png"
            alt="Logo"
          />
          <img
            class="hidden h-14 w-14 object-contain dark:block sm:h-16 sm:w-16"
            src="./assets/logo.png"
            alt="Logo"
          />
        </button>
        <div class="flex min-w-0 items-center justify-end gap-1">
          <ng-container *ngTemplateOutlet="headerActions"></ng-container>
        </div>
      </div>
    }
    @if (isDesktopHeader) {
      <div
        class="flex w-full items-center justify-end gap-4 px-5 py-4 shadow-theme-md xl:px-0 xl:shadow-none"
      >
        <ng-container *ngTemplateOutlet="headerActions"></ng-container>
      </div>
    }
  </div>
</header>

<ng-template #headerActions>
  <div class="flex min-w-0 items-center justify-end gap-1 sm:gap-2 xl:gap-3">
    @if (isImpersonating()) {
      <button
        type="button"
        (click)="returnToOriginalUser()"
        [disabled]="returningToOriginal()"
        [attr.aria-busy]="returningToOriginal()"
        [title]="impersonationError() || 'Stop viewing the system as this user'"
        class="cms-busy-button inline-flex h-10 min-w-0 max-w-[220px] shrink items-center gap-2 rounded-full border border-amber-300 bg-amber-50 px-3 text-sm font-semibold text-amber-800 shadow-sm transition hover:bg-amber-100 disabled:cursor-wait disabled:opacity-70 dark:border-amber-700 dark:bg-amber-950/40 dark:text-amber-200 dark:hover:bg-amber-950/60 xl:h-11 xl:max-w-[320px] xl:px-4"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          class="h-4 w-4 shrink-0"
          aria-hidden="true"
        >
          <path
            d="M9 7 4 12l5 5M4 12h10a6 6 0 0 1 6 6"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span class="truncate">
          {{ returningToOriginal() ? 'Returning...' : 'Back to ' + originalUserName() }}
        </span>
      </button>
    }
    @if (canReadEmailInbox() && emailMailboxEnabled()) {
      <a
        routerLink="/email-mailbox"
        aria-label="Email Inbox"
        title="Email Inbox"
        class="relative flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white xl:h-11 xl:w-11"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M4.5 6.75C4.5 5.50736 5.50736 4.5 6.75 4.5H17.25C18.4926 4.5 19.5 5.50736 19.5 6.75V17.25C19.5 18.4926 18.4926 19.5 17.25 19.5H6.75C5.50736 19.5 4.5 18.4926 4.5 17.25V6.75ZM6.75 6C6.51627 6 6.30668 6.10676 6.16914 6.27428L12 11.0081L17.8309 6.27428C17.6933 6.10676 17.4837 6 17.25 6H6.75ZM18 7.85169L12.4727 12.3398C12.1971 12.5637 11.8029 12.5637 11.5273 12.3398L6 7.85169V17.25C6 17.6642 6.33579 18 6.75 18H17.25C17.6642 18 18 17.6642 18 17.25V7.85169Z"
            fill="currentColor"
          />
        </svg>
      </a>
    }
    @if (canReadCalendar()) {
      <a
        routerLink="/audit/calendar"
        target="_blank"
        rel="noopener noreferrer"
        (click)="prepareCalendarTabSession()"
        aria-label="Audit Calendar"
        title="Audit Calendar"
        class="relative flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white xl:h-11 xl:w-11"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="2em"
          height="1em"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8 2C8.41421 2 8.75 2.33579 8.75 2.75V3.75H15.25V2.75C15.25 2.33579 15.5858 2 16 2C16.4142 2 16.75 2.33579 16.75 2.75V3.75H18.5C19.7426 3.75 20.75 4.75736 20.75 6V9V19C20.75 20.2426 19.7426 21.25 18.5 21.25H5.5C4.25736 21.25 3.25 20.2426 3.25 19V9V6C3.25 4.75736 4.25736 3.75 5.5 3.75H7.25V2.75C7.25 2.33579 7.58579 2 8 2ZM8 5.25H5.5C5.08579 5.25 4.75 5.58579 4.75 6V8.25H19.25V6C19.25 5.58579 18.9142 5.25 18.5 5.25H16H8ZM19.25 9.75H4.75V19C4.75 19.4142 5.08579 19.75 5.5 19.75H18.5C18.9142 19.75 19.25 19.4142 19.25 19V9.75Z"
            fill="currentColor"
          ></path>
        </svg>
      </a>
    }
    @if (canShowTestingControls()) {
      <div class="relative shrink-0">
        <button
          type="button"
          (click)="toggleTestingMenu()"
          aria-label="Testing controls"
          title="Testing controls"
          class="dropdown-toggle relative flex h-10 w-10 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white xl:h-11 xl:w-11"
          [ngClass]="
            errorAlertDebug.showTestErrors()
              ? 'border-red-300 bg-red-50 text-red-600 dark:border-red-800 dark:bg-red-950/30 dark:text-red-300'
              : ''
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M9 3.75C9 3.33579 9.33579 3 9.75 3H14.25C14.6642 3 15 3.33579 15 3.75C15 4.16421 14.6642 4.5 14.25 4.5H13.5V9.09005L18.6169 17.1634C19.5674 18.6629 18.49 20.625 16.7145 20.625H7.28546C5.51002 20.625 4.43257 18.6629 5.38311 17.1634L10.5 9.09005V4.5H9.75C9.33579 4.5 9 4.16421 9 3.75ZM12 10.2861L6.65042 18.7247C6.33357 19.2245 6.69272 19.875 7.28546 19.875H16.7145C17.3073 19.875 17.6664 19.2245 17.3496 18.7247L12 10.2861ZM10.3889 15.75H13.6111L15.0556 18H8.94444L10.3889 15.75Z"
              fill="currentColor"
            />
          </svg>
          @if (errorAlertDebug.showTestErrors()) {
            <span class="absolute right-1 top-1 h-2.5 w-2.5 rounded-full bg-red-500"></span>
          }
        </button>

        <app-dropdown
          [isOpen]="isTestingMenuOpen"
          (close)="closeTestingMenu()"
          className="w-[300px] p-3"
        >
          <div class="border-b border-gray-200 pb-3 dark:border-gray-800">
            <div class="text-sm font-semibold text-gray-800 dark:text-white">Testing</div>
            <div class="mt-1 text-xs text-gray-500 dark:text-gray-400">DCS users only</div>
          </div>

          <button
            type="button"
            class="mt-3 flex w-full items-center justify-between gap-3 rounded-lg px-3 py-2 text-left text-sm font-medium text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/5"
            (click)="toggleTestErrors()"
          >
            <span>Show error alerts</span>
            <span
              class="relative inline-flex h-6 w-11 shrink-0 rounded-full border transition"
              [ngClass]="
                errorAlertDebug.showTestErrors()
                  ? 'border-red-500 bg-red-500'
                  : 'border-gray-300 bg-gray-200 dark:border-gray-700 dark:bg-gray-800'
              "
              aria-hidden="true"
            >
              <span
                class="absolute top-0.5 h-5 w-5 rounded-full bg-white shadow-sm transition"
                [ngClass]="errorAlertDebug.showTestErrors() ? 'left-5' : 'left-0.5'"
              ></span>
            </span>
          </button>

          @if (outlookAppointments.isAvailable()) {
            <button
              type="button"
              class="mt-1 flex w-full items-center justify-between gap-3 rounded-lg px-3 py-2 text-left text-sm font-medium text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/5"
              (click)="toggleOutlookAppointments()"
            >
              <span>Process Outlook appointments</span>
              <span
                class="relative inline-flex h-6 w-11 shrink-0 rounded-full border transition"
                [ngClass]="
                  outlookAppointments.processChanges()
                    ? 'border-brand-500 bg-brand-500'
                    : 'border-gray-300 bg-gray-200 dark:border-gray-700 dark:bg-gray-800'
                "
                aria-hidden="true"
              >
                <span
                  class="absolute top-0.5 h-5 w-5 rounded-full bg-white shadow-sm transition"
                  [ngClass]="outlookAppointments.processChanges() ? 'left-5' : 'left-0.5'"
                ></span>
              </span>
            </button>
          }

          <button
            type="button"
            class="mt-1 flex w-full items-center justify-between gap-3 rounded-lg px-3 py-2 text-left text-sm font-medium text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/5"
            (click)="toggleKeepSidebarExpanded()"
          >
            <span>Keep menu expanded</span>
            <span
              class="relative inline-flex h-6 w-11 shrink-0 rounded-full border transition"
              [ngClass]="
                (sidebar.keepExpandedAfterNavigation$ | async)
                  ? 'border-brand-500 bg-brand-500'
                  : 'border-gray-300 bg-gray-200 dark:border-gray-700 dark:bg-gray-800'
              "
              aria-hidden="true"
            >
              <span
                class="absolute top-0.5 h-5 w-5 rounded-full bg-white shadow-sm transition"
                [ngClass]="(sidebar.keepExpandedAfterNavigation$ | async) ? 'left-5' : 'left-0.5'"
              ></span>
            </span>
          </button>

          <button
            type="button"
            class="mt-1 flex w-full items-center justify-between gap-3 rounded-lg px-3 py-2 text-left text-sm font-medium text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/5"
            (click)="toggleLocalLaunchPhaseMode()"
          >
            <span>Show unreleased items</span>
            <span
              class="relative inline-flex h-6 w-11 shrink-0 rounded-full border transition"
              [ngClass]="
                launchPhases.localPhaseMode() === 'both'
                  ? 'border-brand-500 bg-brand-500'
                  : 'border-gray-300 bg-gray-200 dark:border-gray-700 dark:bg-gray-800'
              "
              aria-hidden="true"
            >
              <span
                class="absolute top-0.5 h-5 w-5 rounded-full bg-white shadow-sm transition"
                [ngClass]="launchPhases.localPhaseMode() === 'both' ? 'left-5' : 'left-0.5'"
              ></span>
            </span>
          </button>
        </app-dropdown>
      </div>
    }
    <app-theme-toggle-button />
    <app-user-dropdown />
  </div>
</ng-template>
